// extracted by mini-css-extract-plugin
export default {"moviesList":"MoviesList_moviesList__P6SP5"};